import { createContext, useContext, useState, useCallback } from "react";
import { TRANSLATIONS } from "@/lib/i18n";

const LanguageContext = createContext(null);

const getInitial = () => {
  if (typeof window !== "undefined") {
    const saved = localStorage.getItem("fohamu_lang");
    if (saved === "en" || saved === "fr") return saved;
  }
  return "en";
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(getInitial);

  const setLang = useCallback((l) => {
    setLangState(l);
    localStorage.setItem("fohamu_lang", l);
  }, []);

  const toggle = useCallback(() => {
    setLangState((prev) => {
      const next = prev === "en" ? "fr" : "en";
      localStorage.setItem("fohamu_lang", next);
      return next;
    });
  }, []);

  // t('section.key') resolves dotted paths; returns the raw value (string/array/object)
  const t = useCallback((path) => {
    const parts = path.split(".");
    let node = TRANSLATIONS[lang];
    for (const p of parts) {
      node = node?.[p];
      if (node === undefined) return path;
    }
    return node;
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggle, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
};
